import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

export const authProcess = gql`
	mutation authProcess($username:String!,$password:String!){
		validateUsers(username:$username,password:$password){
			jsonObject
		}
	}
`

export const createLoginLog = gql`
    mutation createLoginLog($browser: String, $os: String) {
      createLoginLog(browser: $browser, os: $os) {
        loginlog {
          uid
        }
      }
    }
`

export const validateUsers = compose(
	graphql(authProcess,{
		options:{
			errorPolicy: "all",
		},
		name:"authProcess"
	})
);


// WEBPACK FOOTER //
// ./src/views/auth/graph.js